// Assessment Styles
import styled from 'styled-components';
import { Card, Checkbox, Divider, Input, Button } from 'antd';
import { COLORS } from 'theme';
import Flex from 'components/Flex';
import { FilterSection, FilterTitle, FilterGroup } from 'components/FilterStyles';

export const VideoOverlay = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 320px; /* Smaller width */
  height: 240px; /* Fixed aspect ratio height */
  background-color: #000;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  z-index: 1000;
  display: flex;
  flex-direction: column;
`;

export const VideoContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: #000;
`;

export const VideoElement = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

export const VideoControls = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.6);
  padding: 8px 12px;
  color: white;
`;

export const VideoInfo = styled.div`
  font-size: 10px;
  line-height: 1.3;
`;

export const ControlButtons = styled.div`
  display: flex;
  align-items: center;
`;

export const StopButton = styled.button`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #f44336;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: #d32f2f;
  }
  
  svg {
    width: 12px;
    height: 12px;
  }
`;

// export const RedRecordButton = styled.button`
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   background-color: #e53e3e;
//   color: white;
//   border: none;
//   border-radius: 4px;
//   padding: 10px 20px;
//   font-size: 16px;
//   font-weight: 600;
//   cursor: pointer;
//   transition: all 0.2s ease;
//   box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);

//   &:hover {
//     background-color: #c53030;
//   }

//   &:disabled {
//     background-color: #e0e0e0;
//     cursor: not-allowed;
//     opacity: 0.7;
//   }

//   svg {
//     margin-right: 8px;
//   }
// `;

export const RedRecordButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color:rgb(237, 228, 228);
  color: #4B5563;
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 15px;
  font-weight: 500;
  font-family: 'Plus Jakarta Sans', sans-serif;
  cursor: pointer;
  transition: all 0.2s ease;
  margin: 10px 0;
  letter-spacing: 0.3px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  
  &:hover {
    
    transform: translateY(-1px);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
  
  &:active {
    transform: translateY(0);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }
  
  &:disabled {
    background-color: #f2f2f2;
    color: #a0aec0;
    cursor: not-allowed;
    box-shadow: none;
    border: 1px solid #e2e8f0;
  }
  
  svg {
    width: 16px;
    height: 16px;
    margin-right: 10px;
  }
`;

export const AudioContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start; // Changed from center to flex-start
  margin: 20px 0;
  width: 100%;
`;

export const AudioPreview = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  background: #fff;
  padding: 10px 20px;
  border-radius: 8px;
  width: 100%;
  max-width: 600px;

  audio {
    flex: 1;
    height: 40px;
  }

  ${DeleteButton} {
    background: none;
    border: none;
    padding: 8px;
    cursor: pointer;
    
    img {
      width: 20px;
      height: 20px;
    }
  }
`;

export const RecordingControls = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start; // Changed from center to flex-start
  width: 100%;
  gap: 15px;
`;

const breakpoints = {
  mobile: '320px',
  tablet: '768px',
  laptop: '1024px'
};

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
`

export const ModalContent = styled.div`
  background: white;
  padding: 20px;
  border-radius: 5px;
  width: 500px;
  max-width: 100%;
`

export const ModalCheckbox = styled.div`
text-align: center;
gap: 10px;
position: relative;
margin-top: -22px;
padding: 10px;
font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 17.64px;
  color: #A5A5A5;

}
`


export const PageContainer = styled.div`
  padding: 20px;
  background: #fff;
  min-height: calc(100vh - 80px);
  width: calc(100% - 64px);
  box-sizing: border-box;
  overflow-y: auto;
  margin: 40px 32px;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

  @media (max-width: ${breakpoints.tablet}) {
    width: calc(100% - 32px);
    margin: 20px 16px;
    padding: 16px;
  }

  @media (max-width: ${breakpoints.mobile}) {
    width: 100%;
    margin: 10px 0;
    padding: 12px;
  }
`

export const ContentWrapper = styled.div`
  padding: 20px 40px;
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;
  min-height: 580px;

  @media (max-width: ${breakpoints.tablet}) {
    padding: 16px 20px;
  }

  @media (max-width: ${breakpoints.mobile}) {
    padding: 12px;
  }
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
  
  @media (max-width: ${breakpoints.mobile}) {
    flex-direction: column;
    gap: 16px;
    margin-bottom: 24px;
  }
`

export const Title = styled.h1`
  font-size: 16px;
  font-weight: 500;
  color: #000;
  margin: 0;

  @media (max-width: ${breakpoints.mobile}) {
    font-size: 14px;
    text-align: center;
  }
`



export const ShowingTextContainer = styled.div`
  flex: 0.2;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-left: 1px solid #E5E7EB;
  min-width: 180px;
  background: white;

  @media (max-width: ${breakpoints.tablet}) {
    border-left: none;
    border-top: 1px solid #E5E7EB;
    padding: 12px;
  }
`;

export const ShowingText = styled.span`
  color: ${COLORS.TEXT_MEDIUM_EMPHASIS};
  font-size: 14px;
  white-space: nowrap;

  @media (max-width: ${breakpoints.mobile}) {
    font-size: 12px;
  }
`;

export const AssessmentDetails = styled.div`
  margin-bottom: 32px;

  @media (max-width: ${breakpoints.mobile}) {
    margin-bottom: 24px;
  }
`

export const AssessmentName = styled.div`
  font-size: 14px;
  color: #666;
  margin-bottom: 16px;

  @media (max-width: ${breakpoints.mobile}) {
    font-size: 13px;
    margin-bottom: 12px;
  }
`

export const TimeLeft = styled.span`
  color: #666;

  @media (max-width: ${breakpoints.mobile}) {
    font-size: 13px;
  }
`

export const InstructionSection = styled.div`
  margin-bottom: 32px;

  @media (max-width: ${breakpoints.mobile}) {
    margin-bottom: 24px;
  }
`


export const SectionTitle = styled.h2`
  font-size: 16px;
  font-weight: 500;
  color: #000;
  margin: 0 0 16px;

  @media (max-width: ${breakpoints.mobile}) {
    font-size: 14px;
    margin: 0 0 12px;
  }
`

export const InstructionText = styled.p`
  font-size: 14px;
  color: #666;
  line-height: 1.5;
  margin: 0;

  @media (max-width: ${breakpoints.mobile}) {
    font-size: 13px;
    line-height: 1.4;
  }
`

export const List = styled.ul`
  list-style-type: disc;
  margin: 0;
  padding-left: 20px;

  @media (max-width: ${breakpoints.mobile}) {
    padding-left: 16px;
  }
`

export const SubList = styled.ul`
  list-style-type: circle;
  margin: 8px 0;
  padding-left: 20px;

  @media (max-width: ${breakpoints.mobile}) {
    margin: 6px 0;
    padding-left: 16px;
  }
`

export const ListItem = styled.li`
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
  line-height: 1.5;

  @media (max-width: ${breakpoints.mobile}) {
    font-size: 13px;
    margin-bottom: 6px;
    line-height: 1.4;
  }
`

export const Separator = styled.hr`
  border: none;
  border-top: 1px solid #e5e7eb;
  margin: 32px 0;

  @media (max-width: ${breakpoints.mobile}) {
    margin: 24px 0;
  }
`

export const StartButton = styled.button`
  margin-top: 32px;
  background: ${props => props.allChecksComplete ? '#4f46e5' : '#d1d5db'};
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: ${props => props.allChecksComplete ? 'pointer' : 'not-allowed'};
  display: block;
  transition: background-color 0.3s ease;

  @media (max-width: ${breakpoints.mobile}) {
    margin-top: 24px;
    padding: 10px 20px;
    width: 100%;
    font-size: 13px;
  }

  &:hover {
    background: ${props => props.allChecksComplete ? '#4338ca' : '#d1d5db'};
  }

  &:disabled {
    background: #d1d5db;
    cursor: not-allowed;
    opacity: 0.7;
  }
`

export const AssessmentInfoCard = styled.div`
  padding: 28px 32px;
  border: 1px solid ${COLORS.PAGE_BORDER};
  border-radius: 12px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  background: #FFFFFF;
  width: 100%;
  min-height: 100px;

  @media (max-width: ${breakpoints.tablet}) {
    padding: 20px 24px;
    flex-direction: column;
    align-items: flex-start;
  }

  @media (max-width: ${breakpoints.mobile}) {
    padding: 16px;
    min-height: 80px;
    margin-bottom: 16px;
  }

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;
  }
`;

export const AssessmentInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
`;

export const AssessmentTitle = styled.h3`
  font-size: 16px;
  font-weight: 500;
  color: ${COLORS.TEXT_HIGH_EMPHASIS};
  margin: 0;
`;


export const SearchSection = styled(Flex)`
  display: flex;
  align-items: center;
  width: 100%;
  height: 53px;
  margin: 0 auto 20px;
  border: 1px solid #E5E7EB;
  border-radius: 4px;
  background: white;
  overflow: hidden;

  @media (max-width: ${breakpoints.tablet}) {
    width: 100%;
    flex-direction: column;
    height: auto;
  }
`;

export const SearchInput = styled(Input)`
  flex: 0.8;
  height: 100%;
  border: none;
  
  .ant-input {
    height: 100%;
    border: none;
    padding: 8px 16px;
    
    &::placeholder {
      color: ${COLORS.TEXT_LOW_EMPHASIS};
    }
  }

  .ant-input-prefix {
    margin-right: 12px;
  }
`;

export const NoteSection = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  color: #0052CC;
  font-size: 16px;
`;

export const TabsContainer = styled.div`
  display: flex;
  gap: 32px;
  border-bottom: 1px solid ${COLORS.PAGE_BORDER};
  margin-bottom: 24px;
`;

export const Tab = styled.div`
  padding: 20px 0;
  cursor: pointer;
  color: ${props => props.active ? '#0052CC' : COLORS.TEXT_MEDIUM_EMPHASIS};
  font-weight: ${props => props.active ? '600' : '400'};
  position: relative;

  &:after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: ${props => props.active ? '#0052CC' : 'transparent'};
  }

  &:hover {
    color: #0052CC;
  }
`;


export const CompletedAssessmentCard = styled(AssessmentInfoCard)`
  padding: 24px;
`;

export const CompletedInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const TimeInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 48px;
`;

export const DaysLeft = styled.div`
  font-size: 14px;
  color: #6B7280;
`;

export const DeadlineInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const DeadlineLabel = styled.div`
  font-size: 12px;
  color: #6B7280;
  margin-bottom: 4px;
`;

export const DeadlineTime = styled.div`
  font-size: 14px;
  color: #374151;
`;

export const TakeAssessmentButton = styled.button`
  background: #4F46E5;
  color: white;
  border: none;
  padding: 8px 24px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: background 200ms ease;

  &:hover {
    background: #4338CA;
  }

  /* Locked by an expired contract or an exhausted credit bucket. Greyed AND
     labelled "Locked" with an icon, so colour is never the only signal. */
  &:disabled {
    background: #E5E7EB;
    color: #6B7280;
    cursor: not-allowed;
  }

  &:disabled:hover {
    background: #E5E7EB;
  }
`;

/* Why a card is locked, shown under its disabled button. #B91C1C on white is
   6.4:1, past the 4.5:1 minimum for body text. */
export const LockReason = styled.div`
  color: #B91C1C;
  font-size: 12px;
  line-height: 1.5;
  margin-top: 6px;
  max-width: 280px;
  text-align: right;
`;


export const FilterCard = styled(Card)`
  width: 100%;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  padding: 24px;
  margin-bottom: 24px;
`;

export const AssessmentCard = styled(Card)`
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

export const AssessmentHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  margin-right: 125px;
`

export const AssessmentTimer = styled.div`
  position: fixed;
  top: 180px;
  right: 80px;
  width: 157px;
  height: 44px;
  padding: 9px 20px;
  background: #E8FFF3;
  border-radius: 10px;
  color: #111827;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 18px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border: 1px solid #5DB594;
  z-index: 1000;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
`

export const AssessmentSubtitle = styled.div`
  font-size: 14px;
  color: #6B7280;
  margin-bottom: 24px;
`

export const QuestionContainer = styled.div`
  margin-bottom: 32px;
  width: 100%;
  padding: 16px;
  background: #FFFFFF;
  border: 1px solid ${props => props.unanswered ? '#ff6b6b' : 'transparent'};
  border-radius: 8px;
  box-sizing: border-box;
  transition: border-color 0.3s ease;
`

export const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`

export const OptionLabel = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  cursor: pointer;
  padding: 2px;
`

export const RadioInput = styled.input`
  width: 16px;
  height: 16px;
  margin-top: 2px;
  cursor: pointer;
  accent-color: #4F46E5;

  &:hover {
    box-shadow: 0 0 0 4px rgba(79, 70, 229, 0.1);
  }
`

export const OptionText = styled.span`
  font-size: 14px;
  color: #374151;
  line-height: 1.5;
  word-wrap: break-word;
  overflow-wrap: break-word;
  flex: 1;
`

export const ButtonContainer = styled.div`
  display: flex;
  // flex-direction: column;
  align-items: flex-start;
  width: 200px;
  margin-top: 20px;
  margin-left: 24px;
  margin-bottom: 24px;
  gap: 10px;
`
export const NextButton = styled.button`
  width: 80%;
  padding: 8px 16px;
  background: #4F46E5;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #4338CA;
  }
`

export const AssessmentContainer = styled.div`
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 24px;
  box-sizing: border-box;
  overflow-x: hidden;
  background: #FFFFFF;
`

export const AssessmentContent = styled.div`
  width: 100%;
  padding: 0 16px;
  box-sizing: border-box;
`

export const ClearAllButton = styled.button`
  background: none;
  border: none;
  color: #FF0000;
  cursor: pointer;
  float: right;
  padding: 0;
  font-size: 14px;

  &:hover {
    text-decoration: underline;
    color: #CC0000;
  }
`;

export const FilterHeader = styled(Flex)`
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
`;

export const StyledDivider = styled(Divider)`
  margin: 12px 0;
  border-top: 1px solid ${COLORS.PAGE_BORDER};
`;


export const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

// Update TakeButton to be smaller
export const TakeButton = styled(Button)`
  background: #4f46e5;
  color: white;
  border: none;
  padding: 0 16px; // Increased padding
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px; // Slightly larger font
  font-weight: 600;
  width: auto;
  height: 40px; // Increased height

  &:hover {
    background: #4338ca;
  }

  @media (max-width: ${breakpoints.mobile}) {
    width: 100%;
    padding: 8px 16px;
  }
`;

export const BackButton = styled(Button)`
  margin-right: 0;
  width: auto;
  height: 40px; // Increased height matching TakeButton
  font-size: 16px; // Slightly larger font
  padding: 0 16px; // Increased padding
  background: #fbfaff;
  border-color: #e5e0ff;
  font-weight: 600;
  color: #3249D7;
  &:hover {
    background: #fbfaff;
    border-color: #e5e0ff;
    color: #3249D7;
  }
`;

export const QuestionNumber = styled.div`
  font-size: 14px;
  color: #6B7280;
  margin-bottom: 8px;
`



export const InstructionDeadlineInfo = styled.div`
display: flex;
flex-direction: column;
gap: 2px;
font-size: 14px;
`

export const InstructionTimeLeft = styled.div`
color: #666;
font-size: 13px;
font-weight: 500;
margin-bottom: 4px;
`

export const InstructionDateTime = styled.div`
color: #222;
font-size: 16px;
font-weight: 600;
`
export const InstructionDeadlineSection = styled.div`
  margin-bottom: 24px;
`

export const InstructionDeadlineLabel = styled.div`
  font-size: 12px;
  color: #999;
  font-weight: 500;
  margin-bottom: 4px;
`
export const InstructionTime = styled.div`
color: #222;
font-size: 14px;
font-weight: 500;
`
export const CompletedDate = styled.div`
  text-align: right;
  min-width: 120px;
  margin-right: 32px;
`

export const CompletedLabel = styled.div`
  font-size: 12px;
  color: ${COLORS.TEXT_LOW_EMPHASIS};
  margin-bottom: 4px;
`

export const CompletedDateTime = styled.div`
  font-size: 14px;
  color: ${COLORS.TEXT_HIGH_EMPHASIS};
`;




export const WarningMessage = styled.div`
  color: #dc3545;
  text-align: left;
  font-size: 14px;
  font-weight: 500;
  width: 300px;
  margin-bottom: 5px;
`

export const Section = styled.div`
  margin-bottom: 40px;
  flex-grow: 1;
`

export const Paragraph = styled.p`
width: 89%;  
  font-size: 16px;
  line-height: 1.6;
  color: #4b5563;
  margin-bottom: 24px;
`

export const NavigationSection = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 40px;
  overflow-x: auto;
  padding-bottom: 10px;
  &::-webkit-scrollbar {
    height: 6px;
  }
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }
  &::-webkit-scrollbar-thumb {
    background: #bfbfbf;
    border-radius: 3px;
  }
`

// Video Related Styles
// export const VideoOverlay = styled.div`
//   position: fixed;
//   top: 0;
//   left: 0;
//   right: 0;
//   bottom: 0;
//   background: #1a1a1a;
//   z-index: 1000;
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
// `

// export const VideoOverlay = styled.div`
//   /* Remove full-screen positioning */
//   position: relative;
//   width: 100%;
//   display: flex;
//   flex-direction: column;
// align-items: center;
//   margin: 20px 0;
//   background-color: #f8f8f8;
//   border-radius: 8px;
//   overflow: hidden;
//   box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
// `;

// export const VideoOverlay = styled.div`
//   position: fixed;
//   top: 0;
//   left: 0;
//   right: 0;
//   bottom: 0;
//   background-color: rgba(0, 0, 0, 0.85);
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   justify-content: center;
//   z-index: 1000;
//   padding: 20px;
// `;

export const QuestionOverlay = styled.div`
  background-color: rgba(255, 255, 255, 0.9);
  padding: 15px 20px;
  border-radius: 8px;
  max-width: 80%;
  margin-bottom: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
`;

export const QuestionOverlayText = styled.p`
  font-size: 18px;
  font-weight: 600;
  color: #111827;
  margin: 0;
  text-align: center;
`;

// export const VideoContainer = styled.div`
//   position: relative;
//   width: 100%;
//   height: 100%;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   background: #000;
// `

// export const VideoContainer = styled.div`
//   position: relative;
//   width: 100%;
//   border-radius: 8px;
//   overflow: hidden;
//   background-color: #000;
// `;

// export const VideoElement = styled.video`
//   width: 100%;
//   height: 100%;
//   object-fit: cover;
// `

// export const VideoElement = styled.video`
//   width: 100%;
//   height: auto;
//   max-height: 400px;
//   object-fit: cover;
//   display: block;
// `;

// export const VideoContainer = styled.div`
//   position: relative;
//   width: 80%; /* Increased from original size */
//   max-width: 900px; /* Added maximum width for larger screens */
//   border-radius: 8px;
//   overflow: hidden;
//   background-color: #000;
//   box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
// margin: 0 auto;
// `;

// export const VideoElement = styled.video`
//   width: 100%;
//   height: auto;
//   min-height: 500px; /* Increased minimum height */
//   max-height: 70vh; /* Using viewport height to ensure it fits on screen */
//   object-fit: cover;
//   display: block;
// `;

// export const VideoControls = styled.div`
//   position: absolute;
//   bottom: 0;
//   left: 0;
//   right: 0;
//   padding: 24px;
//   background: linear-gradient(to top, rgba(0, 0, 0, 0.7), transparent);
//   display: flex;
//   justify-content: space-between;
//   align-items: flex-end;
// `

// export const ControlButtons = styled.div`
//   position: absolute;
//   left: 50%;
//   bottom: 24px;
//   transform: translateX(-50%);
//   display: flex;
//   gap: 16px;
//   align-items: center;
// `

export const RecordButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: flex-start; // Changed from center to flex-start
  padding: 12px 0; // Removed left padding
  gap: 12px;
  opacity: ${props => (props.disabled ? '0.5' : '1')};
  pointer-events: ${props => (props.disabled ? 'none' : 'auto')};
`;


// export const StopButton = styled.button`
//   background: #f54b56;
//   border: none;
//   width: 32px;
//   height: 32px;
//   border-radius: 50%;
//   cursor: pointer;
//   display: flex;
//   align-items: center;
//   justify-content: center;
// `

// export const VideoInfo = styled.div`
//   color: white;
//   font-size: 14px;
//   opacity: 0.8;
// `

// Additional UI Elements
export const Note = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #666;
  font-size: 14px;
  // margin-top: 6px;
  text-align: left; // Added to ensure text alignment
  padding-left: 0; // Remove any potential padding
  
  &:before {
    content: '!';
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    background:rgb(244, 239, 239);
    border-radius: 50%;
    color:rgb(213, 36, 13);
  }
`;
export const QuestionInstruction = styled.p`
  font-size: 16px;
  font-weight: 500;
  color: #4B5563;
  margin: 20px 0;
  font-style: italic;
`;

export const RecordedVideo = styled.div`
  margin-top: 16px;
  padding: 12px;
  background: #f5f5f5;
  border-radius: 8px;
  display: flex;
  align-items: left;
  justify-content: space-between;
  span {
    color: #666;
    font-size: 14px;
  }
`

export const DeleteButton = styled.button`
  background: none;
  border: none;
  color: #f54b56;
  cursor: pointer;
  padding: 4px 8px;
`
export const Question = styled.div`
  margin-bottom: 32px;
`

export const QuestionText = styled.h3`
  font-size: 18px;
  font-weight: 500;
  color: #1f2937;
  margin-bottom: 16px;
`

export const Options = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const Option = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s;
  &:hover {
    background: #f3f4f6;
  }
  input {
    margin-right: 12px;
  }
`
export const NavigationButtons = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 40px;
  padding-bottom: 24px;
`
export const StyledButton = styled.button`
  padding: 10px 24px;
  border-radius: 8px;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  min-width: 100px;
  border: 1px solid transparent;

  ${props => {
    if (props.variant === 'primary') {
      return `
        background: #3249D7;
        color: white;
        &:hover {
          background: #3a489e;
        }
      `
    } else {
      return `
        background: #FBFAFF;
        color: ${props.skip ? '#3249D7' : '#3249D7'};
        border: 1px solid #E9ECEF;
        &:hover {
          background: #fbfaff;
        }
      `
    }
  }}

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

export const ModalText = styled.div`
  color: #010e30;
  text-align: center;
  font-family: Plus Jakarta Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  margin-bottom: 25px;
`


export const ShortListModalImg = styled.div`
  text-align: center;
  margin-bottom: 25px;
`